<div class="pl-header">
  <pl-current-license></pl-current-license>
  <pl-account-dropdown></pl-account-dropdown>
</div>
